import { __awaiter } from "tslib";
import Controller from "./controller/controller";
import AveApi from "./external-api/ave-api";
import ConfigService from "./services/config-service";
import TimeoutTrackingService from "./services/timeout-tracking-service";
import HttpClient from "./transport/http-client";
import MatchmakerApi from "./external-api/matchmaker-api";
import { EventEmitter } from "events";
import ChunkHandler from "./transport/chunk-handler";
import DatachannelHandler from "./transport/datachannel-handler";
import CirrusApi from "./external-api/cirrus-api";
import { log } from "./utils";
// TODO JetStreamV3 idea:
//  named export initializeJetstream()
//  rename IController, Controller to IJetstream, Jetstream
//  -> usage will be "import {initializeJetstream} from @ave2cloud/jetstream" and "const jetstream = initializeJetstream()"
function initializeJetstream(initConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        log.info("Initializing Jetstream with configuration=", initConfig);
        const configService = new ConfigService(initConfig);
        const timeoutTrackingService = new TimeoutTrackingService(configService);
        const httpClient = new HttpClient(configService);
        const matchmakerApi = new MatchmakerApi(configService, httpClient, initConfig === null || initConfig === void 0 ? void 0 : initConfig.authenticationTokenProvider);
        const eventEmitter = new EventEmitter();
        const chunkHandler = new ChunkHandler(eventEmitter);
        const datachannelHandler = new DatachannelHandler(eventEmitter, chunkHandler);
        const aveApi = new AveApi(timeoutTrackingService, datachannelHandler);
        const cirrusApi = new CirrusApi(configService, timeoutTrackingService, datachannelHandler, httpClient);
        timeoutTrackingService.startUserActivityTracking();
        if (initConfig === null || initConfig === void 0 ? void 0 : initConfig.instanceMatchingUrl) {
            // No need to await this detection.
            matchmakerApi.detectBlockedDomain();
        }
        return new Controller(configService, cirrusApi, aveApi, matchmakerApi, timeoutTrackingService, datachannelHandler, httpClient);
    });
}
const jetStreamApplication = { init: initializeJetstream };
export default jetStreamApplication;
//# sourceMappingURL=app.js.map